export default function() {
  return {
    timeData: null,
    activeTimeSlice: null,
    activeTimeWindow: null,
    activeDays: null,
    activePeaks: null,
    maxTime: Date.now(),
    showTimeFilters: false,
    showBottomPanel: true,
  };
}
